/* eslint-disable @next/next/no-img-element */
import { ErrorMessage, BoldText, MediumText } from './styles';
import { ASSETS } from 'src/common/utils/config';

const Index = ({
  title = 'Oops... Something went wrong.',
  desc = '',
  height = '85vh',
}) => {
  return (
    <ErrorMessage height={height}>
      <img
        src={ASSETS.FALLEN_GLASS}
        alt="error"
        width={'80px'}
        height={'80px'}
      />
      <BoldText>{title}</BoldText>
      <MediumText>{desc}</MediumText>
    </ErrorMessage>
  );
};

export default Index;
